import { render, staticRenderFns } from "./ProvidersAdd.vue?vue&type=template&id=63d146e0"
import script from "./ProvidersAdd.vue?vue&type=script&lang=js"
export * from "./ProvidersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports